module.exports = __webpack_public_path__ + "static/img/cpzx_tu13.97a7957.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spzx_xqy/cpzx_tu13.png
// module id = By2Z
// module chunks = 1